import { User } from "@tamagui/lucide-icons";
import { useLocalSearchParams, usePathname } from "expo-router";
import { useContext } from "react";
import { View, getTokenValue } from "tamagui";

import { Button } from "@/components/Button";
import { LayoutContext } from "@/components/LayoutProvider";
import Logo from "@/components/Logo";
import { Link } from "@/components/Typography";
import SidebarChrome from "@/conversation/sidebar/SidebarChrome";
import SidebarSignin from "@/conversation/sidebar/SidebarSignin";
import { useCurrentConversationId } from "@/hooks/conversation";
import { useUseCaseStore } from "@/store";

const AuthenticationBar = () => {
  const pathname = usePathname();
  const { useCase: useCaseParam } = useLocalSearchParams<{
    useCase?: string;
  }>();
  const { getConversationUseCase } = useUseCaseStore();
  const { setModalContent } = useContext(LayoutContext);
  const currentConversationId = useCurrentConversationId();

  const handleSignin = () => {
    setModalContent(
      () => (props: { onClose: () => void }) => (
        <SidebarChrome {...props} dataTrackingIdPrefix="auth-bar-signin">
          <SidebarSignin
            conversationId={currentConversationId}
            onContinue={() => setModalContent(null)}
          />
        </SidebarChrome>
      ),
      { width: 400 },
    );
  };

  const isOnSignInPage = pathname === "/sign-in";
  const useCaseFromStore = currentConversationId
    ? getConversationUseCase(currentConversationId)
    : undefined;
  const useCaseString = useCaseFromStore ?? useCaseParam;
  const logoHref = useCaseString ? `/about/${useCaseString}` : "/";
  // disable logo link on conversation page
  const logo = !!currentConversationId ? (
    <View
      position="absolute"
      left="$screenPadding"
      top="$250"
      $lg={{
        left: 2 * getTokenValue("$screenPadding"),
      }}
    >
      <Logo />
    </View>
  ) : (
    <Link
      href={logoHref}
      aria-label="Home"
      position="absolute"
      left="$screenPadding"
      top="$250"
      $lg={{
        left: 2 * getTokenValue("$screenPadding"),
      }}
    >
      <Logo />
    </Link>
  );

  return (
    <>
      {logo}
      {!isOnSignInPage && (
        <Button
          marginLeft="auto"
          marginRight="$screenPadding"
          icon={User}
          mode="primary"
          onPress={handleSignin}
          $lg={{
            marginTop: "$100",
            marginRight:
              getTokenValue("$screenPadding") + getTokenValue("$200"),
          }}
        >
          Log in
        </Button>
      )}
    </>
  );
};

export default AuthenticationBar;
